import { Component } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DevMyTitleService } from 'src/app/onelog/services/dev-my-title.service';
import { ProductSatusService } from 'src/app/onelog/services/product-status.service';
import { PPD_DUMP_URL } from 'src/app/onelog/common/config/url';
import {
  DROP_DOWN_LIST_BOOK_TYPE,
  DROP_DOWN_SETTING_BOOKTYPE,
  SELECT_TYPE_DROP_DOWN_OPTIONS,
  SELECT_STATUS_TYPE_DROP_DOWN_OPTIONS,
  DEFAULT_SELECTED_OPTION_TYPE,
} from 'src/app/onelog/common/config/dropdown-config';
import { PAGE_SIZE, MAX_SIZE } from 'src/app/onelog/common/config/common';

@Component({
  selector: 'app-ppd-dump',
  templateUrl: './ppd-dump.component.html',
  styleUrls: ['./ppd-dump.component.css'],
})
export class PpdDumpComponent {
  products: any = [];
  responseData: any = [];
  totalProducts: number = 0;
  perPage: number = 10;
  lastPage: number = 0;
  currentPage: number = 0;
  cancelledStatus: string = 'Cancelled';
  selectedproductId: string = '';
  showSearchLoading: boolean = false;
  showDownloadLoading: boolean = false;
  searchBtnText: string = 'Search';
  downloadBtnText: string = 'Download';
  ppdSelectedFilterData: any = [];
  selectedUserIDFilterType: any = [];
  selectedStatusFilterType: string = '';
  publishedDateSelectedFilterData: any = [];
  selectedPPD: string = '';
  pageSize: number = PAGE_SIZE;
  maxSize: number = MAX_SIZE;

  selectTypeDropDownOptions: any = SELECT_TYPE_DROP_DOWN_OPTIONS;

  selectStatusTypeDropDownOptions: any = SELECT_STATUS_TYPE_DROP_DOWN_OPTIONS;

  DefaultselectedOptionType: string = DEFAULT_SELECTED_OPTION_TYPE;
  dropdownSettingsBookType: IDropdownSettings = {};
  dropdownListBookStatus: any = [];
  productStatusList: any = [];
  selectedDefaultItemsStatus: any = [];
  selectedStatusType: any = [];
  selectedProductType: any = [];

  selectedBookType: any = [];
  selectedPublisher: any = [];
  dropdownListBookType: any = [];
  commitDateSelectedFilterData: any = [];
  selectedStatusFilter: any = [];
  selectedUserIDFilterData: any = [];

  constructor(
    private devMyTitleService: DevMyTitleService,
    private productStatus: ProductSatusService
  ) {}

  ngOnInit() {
    this.loadProductStatusList();
    this.dropdownSettingsBookType = DROP_DOWN_SETTING_BOOKTYPE;

    this.dropdownListBookType = DROP_DOWN_LIST_BOOK_TYPE;

    this.loadProducts(this.createPostData());
  }

  loadProducts(postData: any = [], url: string = PPD_DUMP_URL) {
    return this.devMyTitleService
      .postRequest(postData, url)
      .subscribe((data: {}) => {
        this.responseData = data;
        this.products = this.responseData.data;
        this.totalProducts = this.responseData.total;
        this.perPage = this.responseData.per_page;
        this.lastPage = this.responseData.last_page;
        this.currentPage = this.responseData.current_page;
      });
  }

  updatePageData(event: Event) {
    let eventData: any = event;
    console.log(eventData.currentPage);
    let urlParams = '?page=' + eventData.currentPage;
    this.loadProducts(this.createPostData(), `${PPD_DUMP_URL}${urlParams}`);
  }

  searchProduct() {
    this.setStatusFilterData();

    this.loadProducts(this.createPostData());
  }

  setStatusFilterData() {
    if (
      this.selectedStatusFilterType !== null &&
      this.selectedStatusType.length > 0
    ) {
      this.selectedStatusFilter['selectedFilterType'] =
        this.selectedStatusFilterType;
      this.selectedStatusFilter['selected'] = this.selectedStatusType;
    }

    if (
      this.selectedUserIDFilterType !== null &&
      this.selectedUserIDFilterType !== ''
    ) {
      this.selectedUserIDFilterData['selectedFilterType'] =
        this.selectedUserIDFilterType;
    }

    console.log(this.selectedUserIDFilterData, this.selectedStatusType.length);
  }

  createPostData() {
    this.setStatusFilterData();

    return {
      selectedBookType: this.selectedBookType,
      selectedProductType: this.selectedProductType,
      selectedproductId: this.selectedproductId,

      selectedPPD: Object.assign({}, this.ppdSelectedFilterData),
      selectedPublishedDate: Object.assign(
        {},
        this.publishedDateSelectedFilterData
      ),
      selectedStatus: Object.assign({}, this.selectedStatusFilter),
      selectedUserID: Object.assign({}, this.selectedUserIDFilterData),
      selectedCommitDate: Object.assign({}, this.commitDateSelectedFilterData),
    };
  }

  downloadReport() {
    this.setStatusFilterData();

    this.devMyTitleService.download(
      {
        is_download: 1,
        selectedBookType: this.selectedBookType,
        selectedProductType: this.selectedProductType,
        selectedproductId: this.selectedproductId,
        selectedPPD: Object.assign({}, this.ppdSelectedFilterData),
        selectedPublishedDate: Object.assign(
          {},
          this.publishedDateSelectedFilterData
        ),
        selectedStatus: Object.assign({}, this.selectedStatusFilter),
        selectedUserID: Object.assign({}, this.selectedUserIDFilterData),
        selectedPublisher: this.selectedPublisher,
      },
      '',
      PPD_DUMP_URL
    );
  }

  updateSelectedType(event: any) {
    console.log(event);

    if (event.name == 'ppdDate') {
      this.ppdSelectedFilterData['selectedFilterType'] = event.selectedOption;
    }

    if (event.name == 'publishedDate') {
      this.publishedDateSelectedFilterData['selectedFilterType'] =
        event.selectedOption;
    }

    if (event.name == 'status') {
      this.selectedStatusFilterType = event.selectedOption;
    }

    if (event.name == 'commitDate') {
      this.commitDateSelectedFilterData['selectedFilterType'] =
        event.selectedOption;
    }
  }

  updateSelectedDate(event: any) {
    console.log(event);

    if (event.type == 'ppdDate') {
      this.ppdSelectedFilterData['date'] = event.dateString;
    }

    if (event.type == 'publishedDate') {
      this.publishedDateSelectedFilterData['date'] = event.dateString;
    }

    if (event.type == 'commitDate') {
      this.commitDateSelectedFilterData['date'] = event.dateString;
    }
  }

  loadProductStatusList() {
    return this.productStatus.getStatusList().subscribe((data: {}) => {
      this.productStatusList = data;
      let statusList: any = [];
      let selectedStatusList: any = [];
      let defaultStatusList: any = [];
      let tempSelectedDd: any = [];
      this.productStatusList.data.forEach(function (
        currentValue: any,
        index: any,
        arr: any
      ) {
        let obj: any = {};
        obj['item_id'] = currentValue.attributes.name;
        obj['item_text'] = currentValue.attributes.name;
        statusList.push(obj);

        if (defaultStatusList.includes(currentValue.attributes.name)) {
          selectedStatusList.push(obj);
          tempSelectedDd.push(currentValue.attributes.name);
        }
      });

      this.dropdownListBookStatus = statusList;

      this.selectedDefaultItemsStatus = selectedStatusList;
      this.selectedStatusType = tempSelectedDd;
    });
  }

  updateSelectedDropDown(event: Event) {
    const data: any = event;

    if (data.type == 'bookType') {
      if (data.action == 'selected') {
        this.selectedBookType.push(data.item.item_text);
      } else {
        const index = this.selectedBookType.indexOf(data.item.item_text);
        this.selectedBookType.splice(index, 1);
      }
    }

    if (data.type == 'bookStatus') {
      if (data.action == 'selected') {
        this.selectedStatusType.push(data.item.item_text);
      } else {
        const index = this.selectedStatusType.indexOf(data.item.item_text);
        this.selectedStatusType.splice(index, 1);
      }
    }
  }
}
